import { PayoutType } from 'common/dist/infrastructure/modules/game/interfaces/TournamentTypes';

const USDollarsFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const AEDollarsFormatter = new Intl.NumberFormat('en-AE', {
  style: 'currency',
  currency: 'AED',
  currencyDisplay: 'code',

  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const isGuaranteedPrize = (payoutType: PayoutType, minPayout: number, potAmount: number) =>
  payoutType === PayoutType.FIXED ? true : minPayout >= potAmount;

export const getTotalPrizes = (payoutType: PayoutType, minPayout: number, potAmount: number) =>
  isGuaranteedPrize(payoutType, minPayout, potAmount) ? minPayout : potAmount;

export const formatToCurrency = (price: string | number | undefined, isUAE?: boolean) => {
  if (price === 0) {
    return isUAE ? '0 AED' : '$0';
  }
  if (!price) {
    return null;
  }
  if (typeof price === 'string') {
    return isUAE
      ? AEDollarsFormatter.format(Number(price)).replace(/^([A-Z]{3})\s*(.+)$/, '$2 $1')
      : USDollarsFormatter.format(Number(price));
  }
  if (typeof price === 'number') {
    return isUAE
      ? AEDollarsFormatter.format(price).replace(/^([A-Z]{3})\s*(.+)$/, '$2 $1')
      : USDollarsFormatter.format(price);
  }
};
